import React from "react";
import { BrowserRouter } from "react-router-dom";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";
import Routes from "./Routes.js";
//import Footer from 'pages/Footer';
import ErrorBoundary from "./components/ErrorBoundary";
import GestdocChat from "./components/GestdocChat";

const store = configureStore();

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <div className="gd-app-wrap">
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
          <GestdocChat
            context="flow"
            primaryColor="#06b6d4"
          />
        </div>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
